// extracted by mini-css-extract-plugin
export var ol = "List-module--ol--PqM8x";